import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useProfile } from "../Hooks/UserHooks";

const AuthProtected = ({ children }) => {
  const { userProfile, loading } = useProfile();
  // console.log({ userProfile })
  const location = useLocation();

  // Handle loading state: Do not redirect while loading
  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  // Redirect to login if not authenticated
  if (!userProfile) {
    return (
      <Navigate
        to={{
          pathname: "/login",
          state: { from: location }, // Preserve the current location for redirection after login
        }}
      />
    );
  }

  // Render children if authenticated
  return <>{children}</>;
};

export default AuthProtected;